import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import WorkCard from '@/components/base/WorkCard';
import { getHotWorks, getTopRatedWorks } from '@/utils/content';

const tabs = [
  { key: 'hot', label: '按热度排序' },
  { key: 'rating', label: '按评分排序' },
];

export default function HotWorks() {
  const [tab, setTab] = useState<'hot' | 'rating'>('hot');
  const list = tab === 'hot' ? getHotWorks(8) : getTopRatedWorks(8);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="TOP PICKS"
          title="热门影视推荐"
          description="根据站内浏览热度与编辑推荐综合排列，看看大家都在追什么。"
          linkTo="/category/movie"
          linkLabel="进入分类"
        />

        <div className="mb-6 inline-flex rounded-full bg-background-200 p-1">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key as 'hot' | 'rating')}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                tab === item.key ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
          {list.map((work, index) => (
            <div key={work.id} className="relative">
              {index < 3 && (
                <span className="absolute -left-1 -top-1 z-10 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-primary-950">
                  {index + 1}
                </span>
              )}
              <WorkCard work={work} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}